import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" {...props}>
    <path
      d="m1 11 5-5-5-5"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconChevronRight = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconChevronRight;
